import { TIntlDictionary } from 'types/i18n';
import { TChangePasswordFormValues } from 'types/state';
import { stringOrVoid } from 'utils/validation';
import {
  stringIsEmpty,
  stringsAreEqual,
  stringLengthLessThan,
} from 'utils/stringUtils';
import { TFormValidation } from 'types/utils';
import { INPUT_PASSWORD_MIN_LENGTH } from 'utils/constants';

type Params = {
  requireActualPassword?: boolean;
};

const defaultParams: Params = {
  requireActualPassword: true,
};

export const createChangePasswordFormValidator = (
  i18n: TIntlDictionary,
  params: Params = defaultParams
) => (
  values: TChangePasswordFormValues
): TFormValidation<TChangePasswordFormValues> => {
  let actualPassword = undefined;

  if (params.requireActualPassword) {
    actualPassword = stringOrVoid(
      stringIsEmpty(values.actualPassword),
      i18n.inputValidationRequired
    );
  }

  return {
    actualPassword,
    nextPassword:
      stringOrVoid(
        stringIsEmpty(values.nextPassword),
        i18n.inputValidationRequired
      ) ||
      stringOrVoid(
        stringLengthLessThan(values.nextPassword, INPUT_PASSWORD_MIN_LENGTH),
        i18n.inputValidationPassswordLength
      ),
    nextPasswordRepeat:
      stringOrVoid(
        stringIsEmpty(values.nextPasswordRepeat),
        i18n.inputValidationRequired
      ) ||
      stringOrVoid(
        !stringsAreEqual(values.nextPassword, values.nextPasswordRepeat),
        i18n.inputValidationPasswordsMatch
      ),
  };
};
